import * as actions_quotes from 'actions/quotes-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import { APPS, PERMISSIONS, QUOTES } from 'components/constants';
import { Ibox } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { navMultipleUrls } from 'components/common/toolbox';
import { numPanels } from 'components/common/toolbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

var _ = require('lodash');

export default function QuotesTab(props) {

    /* Hooks ------------------------------------------------------------------------------------------------------------------------------------*/

    const seg = 9;
    const history = useHistory();
    const routeLocation = useLocation();
    const params = useParams();
    const dispatch = useDispatch();

    const quotes = useSelector((store) => store.quotes);
    const user = useSelector((store) => store.users.user);
    const user_permissions = useSelector((store) => store.users.user_permissions);

    const approved_quote = quotes.quote_approved;

    /* Effects ------------------------------------------------------------------------------------------------------------------------------------*/

    useEffect(() => {
        if (params.appId == APPS.DISPATCH.id) {
            var field = (props.source == 'customers') ? 'customerId' : 'serviceRequestId';
            var value = (props.source == 'customers') ? params.customer_id : params.request_id;
        } else {
            var field = (props.source == 'customers') ? 'customerId' : 'serviceRequestId';
            var value = (props.source == 'customers') ? params.customer_id : params.request_id;
        }
        dispatch(actions_quotes.subQuotesByField(params.handle, field, value));

        return () => {
            let unsubscribe = quotes.quotes_unsubscribe;
            if (typeof unsubscribe === 'function') unsubscribe();
            dispatch(actions_quotes.clearQuotes());
        };
    }, [params.request_id, params.customer_id, params.tab_id]);

    /* Constants ------------------------------------------------------------------------------------------------------------------------------------*/

    const handleClick = (quote) => {
        if (props.source == "customers") {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, replace: true, user, urlArray: [
                toolbox.modifyPath(routeLocation.pathname, seg-2, `service_requests`),
                toolbox.modifyPath(routeLocation.pathname, seg-2, `service_requests/${quote.serviceRequestId}/quotes`),
                toolbox.modifyPath(routeLocation.pathname, seg-2, `service_requests/${quote.serviceRequestId}/quotes/${quote.id}/items`),
            ]});
        } else {
            let location = toolbox.modifyPath(routeLocation.pathname, seg, `quotes/${quote.id}`);
            location = toolbox.modifyPathIfEmpty(location, seg + 2, 'items');
            history.push({ pathname: location });
        }
    };
    const newQuote = () => {
        let location = toolbox.modifyPath(routeLocation.pathname, seg-4, `quote-form/0`);
        history.push({ pathname: location });
    };
    
    /* Constants ------------------------------------------------------------------------------------------------------------------------------------*/

    var data = [];
    quotes?.quotes?.forEach((quote) => {
        let status = _.find(Object.values(QUOTES), { id: quote.statusId });
        if (status) data.push({ ...quote, 
            _stripe_color: status?.color,
            status: status.name,
            totalCost: quote?.['totals' + quote.approvedOption]?.grandTotal || 0,
            summary: ((quote?.changeOrder) ? 'CO: ' + quote.summary : quote.summary) });
        });
        
    const redistWidth = 50;
    const redist = (num) => (numPanels() > 1) ? num : num + (num / (100 - redistWidth) * (redistWidth));
    const columns = [
        { name: 'ID', field: 'id', width: redist(10) },
        { name: 'Created', field: 'created', type: 'date', format: 'MMM Do, YYYY', width: redist(25) },
        { name: 'Description', field: 'description', ...(!numPanels(1)) ? { width: 50 } : {} },
        { name: 'Total Cost', field: 'totalCost', type: 'number', format: 'usd', text_align: 'right',width: redist(15) },
    ];


    /* Render ------------------------------------------------------------------------------------------------------------------------------------*/

    return (

        <Ibox title={'Quotes'} show_spinner={quotes.quotes_pending} no_fade={false}
            button={' + Quote'}
            button_callback={newQuote}
            button_disabled={(!user_permissions?.[PERMISSIONS.QUOTES_CREATE.key])}
        >
            <Table
                active_field={'id'}
                active_id={params.tab_id}
                chevron={true}
                click_callback={handleClick}
                columns={columns}
                data={data}
                highlight_search={true}
                max_height={'135px'}
                second_line={(numPanels(1)) ? 'description' : ''}
                second_line_prefix={<i className="fa-solid fa-circle-arrow-right fa-lg mr-1"></i>}
                show_limit={false}
                show_search={false}
            />
        </Ibox>
    );
};